import { Component, Injector, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../service/auth-service/auth-service.service';
import { WebtraderService } from '../../../service/webtrader-service/webtrader.service';
import { Art57Section } from '../../../ui/Art57Section/Art57Section';
import { BulkUpdateListView } from '../../../ui/Data/WebTraderData/BulkUpdateListView';
import { Art57Node } from '../../../ui/Node/Art57Node/Art57Node';
import { parse } from 'date-fns';
import { ConfirmationService } from 'primeng/api';
import { DateUtil } from '../../../ui/DateUtil';


@Component({
  selector: 'app-file-list-detailed-view',
  templateUrl: './file-list-detailed-view.component.html',
  styleUrl: './file-list-detailed-view.component.scss'
})
export class FileListDetailedViewComponent {
  @Input() selectedNode: any;
  sortProperty: number = 1;
  sortOrder = -1;
  loading: boolean = false;

  constructor(private injector: Injector, private confirmationService: ConfirmationService
  ) {
    this.injector.get(WebtraderService).loading.subscribe(value => this.loading = value);
  }



  onCheckedChange(node: Art57Node) {
    node.checked = !node.checked;
  }

  select(item: any) {
    if (item.checked) {
      item.checked = !item.checked;
    } else {
      item.checked = true;
    }
  }

  formatDate(date: any): string {
    return DateUtil.getDateTimeFormat(date);
  }


  sortBy(column: number) {
    this.sortProperty = column;
    this.sortOrder = column === this.sortProperty ? (this.sortOrder * -1) : 1;

    const data = this.selectedNode.data.model;

    const firstRow = data[0];

    var remainingRows = data;
    if (firstRow["fileName"] === "back_arrow") {
      remainingRows = data.slice(1);
    }

    const sortedRows = remainingRows.sort((a: any, b: any) => {
      let result = 0;

      var valueA: any;
      var valueB: any;


      valueA = a[this.selectedNode.getKeys()[column]];
      valueB = b[this.selectedNode.getKeys()[column]];


      if (valueA < valueB) {
        result = -1;
      }

      if (valueA > valueB) {
        result = 1;
      }
      return result * this.sortOrder;
    });
    if (firstRow["fileName"] === "back_arrow") {
      this.selectedNode.data.model = [firstRow, ...sortedRows];
    } else {
      this.selectedNode.data.model = [...sortedRows];
    }
  }

  sortIcon(property: number) {
    if (property === this.sortProperty) {
      return this.sortOrder === 1 ? '↑' : '↓';
    }
    return '';
  }

  getCurrentPath(): string {
    return this.selectedNode.labelPath ? ("Bulk update folder: " + this.selectedNode.labelPath.replaceAll("#", "/")) : "All your bulk update folders";
  }

  getXML(path: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.injector.get(WebtraderService).getBulkUpdateContent(path).subscribe({
        next: (data) => {
          resolve(data.content);
        },
        error: () => {
          reject('');
        }

      });
    })

  }

  onItemFinderClick(item: any) {
    if (!this.isAFile(item)) {
      this.selectedNode.labelPath = item.labelPath;
      this.injector.get(WebtraderService).getBulkUpdateMessages(item.path).subscribe((list: any) => {
        this.selectedNode.data = new BulkUpdateListView(list);
        this.injector.get(WebtraderService).loading.next(false);
      }, (error: any) => {
        this.injector.get(WebtraderService).loading.next(false);
        this.injector.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
      });
    } else {
      //If it is a file then download the file
      this.getXML(item.path).then(data => {
        const link = document.createElement('a');
        let url: string;
        url = URL.createObjectURL(new Blob([data], { type: 'text/xml' }));
        link.href = url;
        link.download = item.fileName;

        this.confirmationService.confirm({
          header: 'Message information',
          message: "Click on the link below to review the XML message.<br><br><a href='" + link.href + "' target='_blank'>" + link.download + "</a>",
          icon: 'pi pi-question-circle',
          acceptLabel: 'Download',
          rejectLabel: 'Close',
          accept: () => {
            link.click();
            URL.revokeObjectURL(url);
          },
          reject: () => {
            URL.revokeObjectURL(url);
          }
        });
      });
    }

  }

  isAFile(item: any): boolean {
    let showCheckbox: boolean = true;
    if (!item.fileName.toLowerCase().endsWith('.xml')) {
      showCheckbox = false;
    }
    return showCheckbox;
  }


}
